import {apiService} from '../apiService';

export const addressService = apiService.injectEndpoints({
    endpoints: (builder) => {
        return {
            getAddress: builder.query({
                query: (postcode) => ({
                    url: `/address/lookup?postcode=${postcode}`
                }),
                transformErrorResponse: (error) => ({
                    message: error?.data?.message || 'Failed to retrieve address.',
                }),
            })
        };
    },
});

export const {
    useGetAddressQuery,
    useLazyGetAddressQuery,
} = addressService;
